import './background.css'

const Background = () => {

      return (
            <div className="background_content">
                  <div className="bg_square"></div>
                  <div className="bg_square"></div>
                  <div className="bg_square"></div>
                  <div className="bg_circle"></div>
                  <div className="bg_circle"></div>
                  <div className="bg_circle"></div>
            </div>
      )
}

export default Background
